import IndividualDevelopmentPlanApprovalView from './component';
import _routes from './routes';

export default IndividualDevelopmentPlanApprovalView;

export const routes = _routes;



// WEBPACK FOOTER //
// ./containers/Group/IndividualDevelopmentPlan/IndividualDevelopmentPlanApprovalView/index.js